import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { paraphrasingData, getDataForDifficulty } from '../courses/data/vocabulary/paraphrasing';

export default function ParaphrasingTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : paraphrasingData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
